export const billingClaimStatusOptions = [
  {
    key: '1',
    value: 'Billed To Patient / Self Pay',
  },
  {
    key: '2',
    value: 'Billed To Prim plan (EDI)',
  },
  {
    key: '3',
    value: 'Billed To Prim plan (Paper',
  },
  {
    key: '4',
    value: 'Billed To Sec plan (EDI)',
  },
  {
    key: '5',
    value: 'Billed To Sec plan (Paper)',
  },
  {
    key: '6',
    value: 'Billed to Tertiary plan - EDI',
  },
  {
    key: '7',
    value: 'Billed to Tertiary plan - Paper',
  },
  {
    key: '8',
    value: 'Cross over',
  },
  {
    key: '9',
    value: 'Duplicate Charge',
  },
  {
    key: '10',
    value: 'Hold Claim',
  },
  {
    key: '11',
    value: 'Medicaid – Not Billable',
  },
  {
    key: '12',
    value: 'Never been billed',
  },
  {
    key: '13',
    value: 'Other',
  },
  {
    key: '14',
    value: 'Paper Claims Client Submission',
  },
  {
    key: '15',
    value: 'Patient Contacted to Resolve COB Issue',
  },
  {
    key: '16',
    value: 'Rejected from Prim plan',
  },
  {
    key: '17',
    value: 'Rejected from Sec plan',
  },
  {
    key: '18',
    value: 'Resubmitted to Prim plan (EDI)',
  },
  {
    key: '19',
    value: 'Resubmitted to Prim plan (Paper)',
  },
  {
    key: '20',
    value: 'Resubmitted to Sec plan (EDI)',
  },
  {
    key: '21',
    value: 'Resubmitted to Sec plan (Paper)',
  },
  {
    key: '22',
    value: 'Settled',
  },
  {
    key: '23',
    value: 'Submitted Corrected Claim via NaviNet portal',
  },
  {
    key: '24',
    value: 'Submitted Corrected Claim via SPOT portal',
  },
  {
    key: '25',
    value: 'Waiting for resubmission to Prim plan (EDI)',
  },
  {
    key: '26',
    value: 'Waiting for resubmission to Prim plan (Paper)',
  },
  {
    key: '27',
    value: 'Waiting for resubmission to Sec plan (EDI)',
  },
  {
    key: '28',
    value: 'Waiting for resubmission to Sec plan (Paper)',
  },
  {
    key: '29',
    value: 'Waiting for resubmission to Tertiary plan - EDI',
  },
  {
    key: '30',
    value: 'Waiting for resubmission to Tertiary plan - Paper',
  },
  {
    key: '31',
    value: 'Waiting to be billed to Prim plan (EDI)',
  },
  {
    key: '32',
    value: 'Waiting to be billed to Prim plan (Paper)',
  },
  {
    key: '33',
    value: 'Waiting to be billed to Sec plan (EDI)',
  },
  {
    key: '34',
    value: 'Waiting to be billed to Sec plan (Paper)',
  },
  {
    key: '35',
    value: 'Waiting to be billed to Tertiary plan - EDI',
  },
  {
    key: '36',
    value: 'Waiting to be billed to Tertiary plan - Paper',
  },
]

// The same list as the posting forms show it: numbered, so a biller can
// read a status back off a charge by its number alone.
export const billingClaimStatusSelectOptions = billingClaimStatusOptions.map((option) => ({
  key: option.key,
  value: `${option.key}. ${option.value}`,
}))

export const billingInsuranceTypeCodeOptions = [
  {
    key: '41',
    value: 'Black Lung',
  },
  {
    key: '43',
    value: 'Disabled Beneficiary Under Age 65 with Large Group Health Plan (LGHP)',
  },
  {
    key: '13',
    value: "End-Stage Renal Disease Beneficiary in the 12 month coordination period with an employer's group health plan",
  },
  {
    key: '14',
    value: 'No-fault Insurance including Auto is Primary',
  },
  {
    key: '47',
    value: 'Other Liability Insurance is Primary',
  },
  {
    key: '16',
    value: 'Public Health Service (PHS) or Other Federal Agency',
  },
  {
    key: '42',
    value: "Veteran's Administration",
  },
  {
    key: '12',
    value: 'Working Aged Beneficiary or Spouse with Employer Group Helath Plan',
  },
  {
    key: '15',
    value: "Worker's Compensation",
  },
]

export const SECONDARY_PAYER_INSURANCE_TYPE_UPAYER_ID = '09102'
